import commonConfig from "./common/common.config";
import objectConfig from "./object/object.config";

export class ReportConfig {
  static readonly common = commonConfig;
  static readonly object = objectConfig;
}
